import React from "react";
import {
  Box,
  Chip,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

// Component to display top selling products
export const TopSellingProductsStats = ({ startDate, endDate, data }) => {
  const theme = useTheme();

  // Find the highest quantity to calculate percentage for progress bars
  const maxQuantity = data?.length
    ? Math.max(...data.map((product) => product.totalQuantity))
    : 0;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <TrendingUpIcon
          size={24}
          color={theme.palette.primary.main}
          style={{ marginRight: 8 }}
        />
        <Typography variant="h6" fontWeight="600">
          Produtos Mais Vendidos
        </Typography>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {startDate ? new Date(startDate).toLocaleDateString() : ""} -{" "}
        {endDate ? new Date(endDate).toLocaleDateString() : ""}
      </Typography>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Produto</TableCell>
              <TableCell align="right">Quantidade</TableCell>
              <TableCell align="right">Receita</TableCell>
              <TableCell align="right">Categoria</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.slice(0, 5).map((product, index) => (
              <TableRow key={product.id}>
                <TableCell>
                  <Box>
                    <Typography variant="body2" fontWeight={500}>
                      {product.title}
                    </Typography>
                    <Box sx={{ width: "100%", mt: 1 }}>
                      <LinearProgress
                        variant="determinate"
                        value={(product.totalQuantity / maxQuantity) * 100}
                        sx={{
                          height: 6,
                          borderRadius: 1,
                          backgroundColor: theme.palette.grey[200],
                          "& .MuiLinearProgress-bar": {
                            backgroundColor: theme.palette.primary.main,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align="right">{product.totalQuantity}</TableCell>
                <TableCell align="right">
                  R$ {product.totalRevenue.toFixed(2)}
                </TableCell>
                <TableCell align="right">
                  <Chip
                    label={product.category}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body2" color="text.secondary">
          Valor médio de pedido:{" "}
          <strong>
            R${" "}
            {data?.length
              ? (
                  data.reduce((acc, p) => acc + p.avgOrderValue, 0) /
                  data.length
                ).toFixed(2)
              : "0.00"}
          </strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Total de produtos: <strong>{data?.length || 0}</strong>
        </Typography>
      </Box>
    </Box>
  );
};
